<template>
	<el-form-item
		:label="item.label"
		:prop="`${item.field}`"
		:hidden="item.options.hidden"
		v-if="item.showed"
		:rules="[
			{
				required: item.required || false,
				message: item.label + '为必填字段',
			},
		]"
	>
		<el-select
			v-model="$attrs.model[item.field]"
			popper-class="test_sec"
			multiple
			filterable
			remote
			reserve-keyword
			placeholder="请输入关键词"
			:remote-method="remoteMethod"
			:loading="loading"
			:style="{ width: item.options.width || '100%' }"
			:disabled="item.options.disabled"
		>
			<el-option v-for="(item, index) in storageList" :key="index" :label="item.code + '   ' + item.name" :value="item.id">
				<span style="float: left">{{ item.code }}</span>
				<span style="float: right; color: #8492a6; font-size: 13px; margin-right: 15px">{{ item.name }}</span>
			</el-option>
			<div class="jcPage">
				<el-pagination v-show="total > 0" small layout="prev, pager, next" :total="total" :current-page.sync="listQuery.page" :page-size.sync="listQuery.limit" @current-change="handleCurrentChange">
				</el-pagination>
			</div>
		</el-select>
	</el-form-item>
</template>

<script>
export default {
	props: {
		item: Object,
		optionList: Array,
	},
	data() {
		return {
			loading: false,
			selVal: '',
			storageList: [],
			total: 0,
			listQuery: {
				page: 1,
				limit: 10000,
			},
		}
	},
	created() {},
	mounted() {
		this.storageList = JSON.parse(JSON.stringify(this.optionList))
	},
	methods: {
		// 搜索检测依据
		remoteMethod(query) {
			let ids = this.$attrs.model[this.item.field]
			console.log(ids, '选中的数据')

			if (query != this.selVal) {
				this.listQuery.page = 1
				this.total = 0
				this.selVal = query
			}

			if (query !== '') {
				this.loading = true
				let arr = []
				ids.forEach(v => {
					this.optionList.forEach(it => {
						if (it.id == v) {
							arr.push(it)
						}
					})
				})
				let brr = this.optionList.filter(item => {
					return item.name.toLowerCase().indexOf(query.toLowerCase()) > -1 || item.code.toLowerCase().indexOf(query.toLowerCase()) > -1
				})

				this.storageList = new Set([...[...arr, ...brr]])
				this.loading = false
			} else {
				this.storageList = JSON.parse(JSON.stringify(this.optionList))
			}
		},
		handleCurrentChange(currpage) {
			this.listQuery.page = currpage
			this.remoteMethod(this.selVal)
		},
	},
}
</script>

<style lang="scss" scoped></style>
